<template>
  <span v-html="mData.noi_dung"></span>
</template>

<script>
import LanguageService from "../service/LanguageService";
import MethodService from "../service/MethodService";

export default {
  props: {
    propData: String
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        noi_dung: ""
      }
    };
  },
  methods: {
    fn_init() {
      this.mData.noi_dung = this.propData.replace(/\n/g, '<br>');
    }
  },
  created: function() {},
  mounted: function() {
    this.fn_init();
  }
};
</script>
<style scoped>
</style>